var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5625 20.3438L39.2344 34.875L2.90625 20.3438L39.2344 5.8125L75.5625 20.3438Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2344 34.875V75.5625L2.90625 61.0312V20.3438L39.2344 34.875Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5625 20.3438V61.0312L39.2344 75.5625V34.875L75.5625 20.3438Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0366 15.3305L27.9581 30.3704L27.6094 30.5157V43.5938L17.4375 39.2344V26.1563L52.5159 11.131L63.0366 15.3305Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.75 87.1875C80.9855 87.1875 90.0938 78.0793 90.0938 66.8438C90.0938 55.6082 80.9855 46.5 69.75 46.5C58.5145 46.5 49.4062 55.6082 49.4062 66.8438C49.4062 78.0793 58.5145 87.1875 69.75 87.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0473 58.5464C77.4806 57.9797 76.5651 57.9797 75.9984 58.5464L69.7645 64.7803L63.5306 58.5464C62.9639 57.9797 62.0484 57.9797 61.4817 58.5464C60.915 59.1131 60.915 60.0286 61.4817 60.5953L67.7156 66.8292L61.4817 73.0631C60.915 73.6298 60.915 74.5453 61.4817 75.112C61.7723 75.4026 62.1356 75.5334 62.5134 75.5334C62.8912 75.5334 63.2545 75.3881 63.5451 75.112L69.779 68.8781L76.0129 75.112C76.3036 75.4026 76.6668 75.5334 77.0446 75.5334C77.4225 75.5334 77.7857 75.3881 78.0764 75.112C78.6431 74.5453 78.6431 73.6298 78.0764 73.0631L71.8425 66.8292L78.0764 60.5953C78.6431 60.0286 78.6431 59.1131 78.0764 58.5464H78.0473Z",
    fill: "#595959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrder);
export default __webpack_public_path__ + "static/media/no-order.c2ea3a3d0496a391277279ebab7cae88.svg";
export { ForwardRef as ReactComponent };